// Currency utilities for Oakbridge

export const DEFAULT_RATES = {
  GBP: { symbol: "\u00a3", rate: 1.0, name: "British Pound" },
  USD: { symbol: "$", rate: 1.27, name: "US Dollar" },
  EUR: { symbol: "\u20ac", rate: 1.17, name: "Euro" },
  CAD: { symbol: "C$", rate: 1.72, name: "Canadian Dollar" },
  AUD: { symbol: "A$", rate: 1.92, name: "Australian Dollar" },
  NZD: { symbol: "NZ$", rate: 2.08, name: "New Zealand Dollar" },
  INR: { symbol: "\u20b9", rate: 106.0, name: "Indian Rupee" },
  JPY: { symbol: "\u00a5", rate: 190.0, name: "Japanese Yen" },
  AED: { symbol: "AED ", rate: 4.66, name: "UAE Dirham" },
  SGD: { symbol: "S$", rate: 1.71, name: "Singapore Dollar" },
  ZAR: { symbol: "R", rate: 23.5, name: "South African Rand" },
};

/**
 * Convert a GBP value into target currency using the supplied rates map.
 * Returns a pretty-formatted string with the symbol.
 */
export function formatPrice(gbpAmount, currency, ratesMap) {
  const info = (ratesMap && ratesMap[currency]) || DEFAULT_RATES[currency] || DEFAULT_RATES.GBP;
  const value = gbpAmount * info.rate;

  // Smart rounding: high-denom currencies round to whole units
  const noDecimals = ["JPY", "INR"].includes(currency) || value >= 1000;
  const rounded = noDecimals ? Math.round(value) : Math.round(value * 100) / 100;
  const formatted = rounded.toLocaleString(undefined, {
    minimumFractionDigits: noDecimals ? 0 : 0,
    maximumFractionDigits: noDecimals ? 0 : 2,
  });
  return `${info.symbol}${formatted}`;
}

/**
 * Format a GBP range like "150–500" in the target currency.
 */
export function formatRange(minGbp, maxGbp, currency, ratesMap) {
  return `${formatPrice(minGbp, currency, ratesMap)} – ${formatPrice(maxGbp, currency, ratesMap)}`;
}
